export interface CatalogGrade {
	GradeId: number | null;
	GradeName: string;
	IsDuplicate: boolean;
	IsActive: boolean;
	Comments: string;
}
export const CATALOG_GRADE_INITIAL_VALUES: CatalogGrade = {
	GradeId: null,
	GradeName: "",
	IsDuplicate: true,
	IsActive: true,
	Comments: "",
};

export interface GradeChemistryLimit {
	GradeId: number;
	ElementId: number | null;
	ElementName: string;
	MinValue: number;
	MaxValue: number;
	AimValue: number | null;
	Enabled: boolean | null;
}
